
/**
 * Shows an alert if the user has not yet confirmed their email address.
 *
 * @param {import('../ForumApplication').default} app
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {

  MD5(string) {
    const rotateLeft = (lValue, iShiftBits) => (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));

    const addUnsigned = (lX, lY) => {
        const lZ = (lX & 0x80000000) | (lY & 0x80000000);
        const lX4 = (lX & 0x7FFFFFFF);
        const lY4 = (lY & 0x7FFFFFFF);
        const lResult = (lX4 + lY4) & 0xFFFFFFFF;
        return lResult ^ lZ;
    };

    const F = (x, y, z) => (x & y) | (~x & z);
    const G = (x, y, z) => (x & z) | (y & ~z);
    const H = (x, y, z) => (x ^ y ^ z);
    const I = (x, y, z) => (y ^ (x | ~z));

    const FF = (a, b, c, d, x, s, ac) => addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, F(b, c, d)), addUnsigned(x, ac)), s), b);
    const GG = (a, b, c, d, x, s, ac) => addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, G(b, c, d)), addUnsigned(x, ac)), s), b);
    const HH = (a, b, c, d, x, s, ac) => addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, H(b, c, d)), addUnsigned(x, ac)), s), b);
    const II = (a, b, c, d, x, s, ac) => addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, I(b, c, d)), addUnsigned(x, ac)), s), b);

    const convertToWordArray = (string) => {
        const lWordCount = (string.length + 8) >> 6;
        const lByteCount = (lWordCount << 4) + 15;
        const lWordArray = new Array(lByteCount);
        for (let i = 0; i < lByteCount; i++) {
            lWordArray[i] = 0;
        }
        for (let i = 0; i < string.length; i++) {
            lWordArray[i >> 2] |= string.charCodeAt(i) << ((i % 4) * 8);
        }
        lWordArray[lWordCount - 1] |= 0x80 << ((string.length % 4) * 8);
        lWordArray[lByteCount - 2] = string.length * 8;
        return lWordArray;
    };

    const utf8Encode = (str) => unescape(encodeURIComponent(str));

    const x = convertToWordArray(utf8Encode(string));
    let a = 0x67452301;
    let b = 0xEFCDAB89;
    let c = 0x98BADCFE;
    let d = 0x10325476;

    for (let k = 0; k < x.length; k += 16) {
        const AA = a;
        const BB = b;
        const CC = c;
        const DD = d;

        a = FF(a, b, c, d, x[k + 0], 7, 0xD76AA478);
        d = FF(d, a, b, c, x[k + 1], 12, 0xE8C7B756);
        c = FF(c, d, a, b, x[k + 2], 17, 0x242070DB);
        b = FF(b, c, d, a, x[k + 3], 22, 0xC1BDCEEE);
        a = FF(a, b, c, d, x[k + 4], 7, 0xF57C0FAF);
        d = FF(d, a, b, c, x[k + 5], 12, 0x4787C62A);
        c = FF(c, d, a, b, x[k + 6], 17, 0xA8304613);
        b = FF(b, c, d, a, x[k + 7], 22, 0xFD469501);
        a = FF(a, b, c, d, x[k + 8], 7, 0x698098D8);
        d = FF(d, a, b, c, x[k + 9], 12, 0x8B44F7AF);
        c = FF(c, d, a, b, x[k + 10], 17, 0xFFFF5BB1);
        b = FF(b, c, d, a, x[k + 11], 22, 0x895CD7BE);
        a = FF(a, b, c, d, x[k + 12], 7, 0x6B901122);
        d = FF(d, a, b, c, x[k + 13], 12, 0xFD987193);
        c = FF(c, d, a, b, x[k + 14], 17, 0xA679438E);
        b = FF(b, c, d, a, x[k + 15], 22, 0x49B40821);

        a = GG(a, b, c, d, x[k + 1], 5, 0xF61E2562);
        d = GG(d, a, b, c, x[k + 6], 9, 0xC040B340);
        c = GG(c, d, a, b, x[k + 11], 14, 0x265E5A51);
        b = GG(b, c, d, a, x[k + 0], 20, 0xE9B6C7AA);
        a = GG(a, b, c, d, x[k + 5], 5, 0xD62F105D);
        d = GG(d, a, b, c, x[k + 10], 9, 0x2441453);
        c = GG(c, d, a, b, x[k + 15], 14, 0xD8A1E681);
        b = GG(b, c, d, a, x[k + 4], 20, 0xE7D3FBC8);
        a = GG(a, b, c, d, x[k + 9], 5, 0x21E1CDE6);
        d = GG(d, a, b, c, x[k + 14], 9, 0xC33707D6);
        c = GG(c, d, a, b, x[k + 3], 14, 0xF4D50D87);
        b = GG(b, c, d, a, x[k + 8], 20, 0x455A14ED);
        a = GG(a, b, c, d, x[k + 13], 5, 0xA9E3E905);
        d = GG(d, a, b, c, x[k + 2], 9, 0xFCEFA3F8);
        c = GG(c, d, a, b, x[k + 7], 14, 0x676F02D9);
        b = GG(b, c, d, a, x[k + 12], 20, 0x8D2A4C8A);

        a = HH(a, b, c, d, x[k + 5], 4, 0xFFFA3942);
        d = HH(d, a, b, c, x[k + 8], 11, 0x8771F681);
        c = HH(c, d, a, b, x[k + 11], 16, 0x6EFA86A);
        b = HH(b, c, d, a, x[k + 14], 23, 0xA4502612);
        a = HH(a, b, c, d, x[k + 1], 4, 0x6F15D0D);
        d = HH(d, a, b, c, x[k + 4], 11, 0x6C2D0D11);
        c = HH(c, d, a, b, x[k + 7], 16, 0x9B043E35);
        b = HH(b, c, d, a, x[k + 10], 23, 0xF87A4403);
        a = HH(a, b, c, d, x[k + 13], 4, 0xE0B09658);
        d = HH(d, a, b, c, x[k + 0], 11, 0x4B0184AA);
        c = HH(c, d, a, b, x[k + 3], 16, 0xA6F4956A);
        b = HH(b, c, d, a, x[k + 6], 23, 0xE9B6C7AA);
        a = HH(a, b, c, d, x[k + 9], 4, 0xD9547F45);
        d = HH(d, a, b, c, x[k + 12], 11, 0xA3D8B3E5);
        c = HH(c, d, a, b, x[k + 15], 16, 0xD3A11EDD);
        b = HH(b, c, d, a, x[k + 2], 23, 0xAEC6D1A9);

        a = II(a, b, c, d, x[k + 0], 6, 0xF4292244);
        d = II(d, a, b, c, x[k + 7], 10, 0x432AF67A);
        c = II(c, d, a, b, x[k + 14], 15, 0xAB0018A3);
        b = II(b, c, d, a, x[k + 5], 21, 0xF761E8DF);
        a = II(a, b, c, d, x[k + 12], 6, 0xE4B96A0A);
        d = II(d, a, b, c, x[k + 3], 10, 0x25E9D05B);
        c = II(c, d, a, b, x[k + 10], 15, 0xB0849A8B);
        b = II(b, c, d, a, x[k + 1], 21, 0x6A28CA61);
        a = II(a, b, c, d, x[k + 8], 6, 0xD34D3937);
        d = II(d, a, b, c, x[k + 15], 10, 0xE25BFD20);
        c = II(c, d, a, b, x[k + 2], 15, 0x434A7BC8);
        b = II(b, c, d, a, x[k + 9], 21, 0xE46B27D1);
        a = II(a, b, c, d, x[k + 16], 6, 0xD9C43F9D);
        d = II(d, a, b, c, x[k + 1], 10, 0x7891238D);
        c = II(c, d, a, b, x[k + 7], 15, 0x10CEAE04);
        b = II(b, c, d, a, x[k + 4], 21, 0xABAB6A0F);

        a = addUnsigned(a, AA);
        b = addUnsigned(b, BB);
        c = addUnsigned(c, CC);
        d = addUnsigned(d, DD);
    }

    const wordToHex = (value) => {
        let hex = '';
        for (let i = 0; i < 4; i++) {
            const byte = (value >> (i * 8)) & 255;
            hex += ('0' + byte.toString(16)).slice(-2);
        }
        return hex;
    };

    return wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
}
}
